import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancelledordermanagement',
  templateUrl: './cancelledordermanagement.component.html',
  styleUrls: ['./cancelledordermanagement.component.css']
})
export class CancelledordermanagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
